export default __webpack_public_path__ + "KaTeX_SansSerif-Italic.e5fc2aef496040d3f44502045a9fa7f6.woff2";